import { _Wallet } from '../types';
export interface PopupManagePayload {
  title: string;
  bearer_token: string;
  redirect_uri: string;
  cid: string;
  action: string;
  create_wallet_api: string;
  secret_type: string;
  raw_data: any;
  data: string;
  user_wallets: UserWallet[];
  wallet_count: number;
  api_root: string;
}

export interface UserWallet {
  id: string;
  address: string;
  full_address: string;
  description: string;
  chain: string;
}

export interface WalletItemProps {
  item: _Wallet;
  api_root?: string;
  bearer_token: string;
}

export enum PopupManagePageState {
  WalletListing = "wallet-listing",
  WalletDetail = "wallet-detail",
  Receive = "receive",
  SendNFT = "send-nft",
}

